import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { OrgContextService } from "src/app/Services/org-context.service";
import { PermissionsService } from "src/app/Services/permissions.service";
import { getLoggedInUser } from "src/app/shared/utils/plan.util";
@Component({
  selector: "app-user-dashboard",
  templateUrl: "./user-dashboard.component.html",
  styleUrls: ["./user-dashboard.component.scss"],
})
export class UserDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  userEmail!: string;
  userData: any;
  blue: string;
  toogleMenuClass: boolean = false;
  isToggleClass!: boolean;
  showOrgContentNav = false;
  showTaskModeReportsNav = false;
  private orgSub?: Subscription;
  private routerSub?: Subscription;

  private static readonly SEGMENT_TO_PAGE: Record<string, string> = {
    dashboard: "dashboard",
    "content-analytics": "analytics",
    "outgoing-tranfer-approvals": "outgoing-tranfer-approvals",
    "incoming-tranfer-approvals": "incoming-tranfer-approvals",
    "access-requests": "access-requests",
    "content-approvals": "content-approvals",
    "guide-reviews": "guide-reviews",
    "org-content": "org-content",
    "task-mode-reports": "task-mode-reports",
    "question-responses": "task-mode-reports",
  };

  constructor(
    public formbuilder: UntypedFormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private eventEmitterService: EventEmitterService,
    private orgContext: OrgContextService,
    private permissions: PermissionsService
  ) {
    this.eventEmitterService.setDashboardMenuProperty.subscribe(
      (name: string) => {
        this.activePage = name;
      }
    );
  }

  addMenutoggleClass() {
    console.log(this.toogleMenuClass);
    this.toogleMenuClass = !this.toogleMenuClass;
    this.isToggleClass = false;
  }

  onOverlayClick(event: Event) {
    // Close menu when clicking outside the menu (on overlay or content area)
    // The menu itself has stopPropagation, so clicks on menu won't reach here
    if (this.toogleMenuClass) {
      this.toogleMenuClass = false;
    }
  }

  toggleShow() {
    this.isToggleClass = !this.isToggleClass;
  }
  activePage: string = "dashboard";
  pageName: string = "Dashboard";
  activeColor: string = "#1d67a3";
  defaultColor: string = "#000"; // Black or any default color

  navigatetopage(navigateTo: string) {
    this.activePage = navigateTo;

    let route = "";
    switch (navigateTo) {
      case "dashboard":
        route = "/user-dashboard/dashboard";
        this.pageName = "Dashboard";
        break;
      case "analytics":
        route = "/user-dashboard/content-analytics";
        this.pageName = "Analytics";
        break;
      case "gift":
        route = "/user-dashboard/gift";
        this.pageName = "Donation";
        break;
      case "pending-consultations":
        route = "/user-dashboard/pending-consultations";
        this.pageName = "Received Consultation";
        break;
      case "my-consultation":
        route = "/user-dashboard/my-consultation";
        this.pageName = "Initiated Consultation";
        break;
      case "outgoing-tranfer-approvals":
        route = "/user-dashboard/outgoing-tranfer-approvals";
        this.pageName = "Outgoing Transfer Approvals";
        break;
      case "incoming-tranfer-approvals":
        route = "/user-dashboard/incoming-tranfer-approvals";
        this.pageName = "Incoming Transfer Approvals";
        break;
      case "access-requests":
        route = "/user-dashboard/access-requests";
        this.pageName = "Access Requests";
        break;
      case "content-approvals":
        route = "/user-dashboard/content-approvals";
        this.pageName = "Publishing Approvals";
        break;
      case "guide-reviews":
      case "flow-reviews":
        route = "/user-dashboard/guide-reviews";
        this.pageName = "Guide Feedback";
        break;
      case "org-content":
        route = "/user-dashboard/org-content";
        this.pageName = "Organization content";
        break;
      case "task-mode-reports":
        route = "/user-dashboard/task-mode-reports";
        this.pageName = "Task Mode Reports";
        break;
      case "question-responses":
        route = "/user-dashboard/task-mode-reports?tab=responses";
        this.pageName = "Task Mode Reports";
        break;
      default:
        route = "/user-dashboard/dashboard"; // fallback
    }

    this.router.navigateByUrl(route);
    this.toogleMenuClass = !this.toogleMenuClass;

    this.eventEmitterService.setDashboardMenuStyleProperty(navigateTo);
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.userEmail = "";

    if (this.userData != null) {
      this.userEmail = this.userData.emailAddress;
    } else {
      this.router.navigate(["/"]);
    }

    this.refreshOrgContentNav();
    this.orgSub = this.orgContext.watch().subscribe(() => this.refreshOrgContentNav());

    this.syncActivePageFromUrl(this.router.url);
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.syncActivePageFromUrl(e.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this.orgSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }

  private syncActivePageFromUrl(url: string): void {
    const segment = (url || "").split("?")[0].split("#")[0].split("/")[2] || "dashboard";
    const page = UserDashboardComponent.SEGMENT_TO_PAGE[segment];
    if (page) this.activePage = page;
  }

  private refreshOrgContentNav(): void {
    this.showOrgContentNav = this.orgContext.isOrgAdminUser();
    this.showTaskModeReportsNav = this.canShowTaskModeReportsNav();
  }

  private canShowTaskModeReportsNav(): boolean {
    const user = this.userData || getLoggedInUser();
    const role = this.permissions.resolveEffectiveRole(user);
    if (role === "Super Admin" || role === "Admin") return true;
    if (this.orgContext.isOrganizationMode()) {
      return this.orgContext.canViewUsersTab();
    }
    return role === "Content Creator";
  }

  ngAfterViewInit(): void {
    this.eventEmitterService.setPageDashboardProperty(true);
    if (this.userData != null) {
      this.userEmail = this.userData.emailAddress;
    } else {
      this.router.navigate(["/"]);
    }

    // On mobile, open the dashboard side menu by default
    // so that items like Analytics are immediately visible
    if (window && window.innerWidth <= 767) {
      this.toogleMenuClass = true;
    }
  }
}
